module.exports = __webpack_public_path__ + "img/promo-enero.a3cfc1f4.a3cfc1f4.jpg";